import { doc, updateDoc, getDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";

/**
 * Saves pillar estimates (overwrite) and overall estimate history (daily)
 * EVERYTHING is written directly on users/{uid}
 */
export const saveAnalyticsResults = async ({
  uid,
  pillarEstimates,   // { english: {...}, math: {...} }
  overallEstimate,   // { english, math, total }
  source,            // "diagnostic" | "promotion"
}) => {
  if (!uid) throw new Error("saveAnalyticsResults: missing uid");

  const userRef = doc(db, "users", uid);

  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD

  const updatePayload = {};

  /* ---------- overwrite pillar estimates ---------- */
  if (pillarEstimates?.english) {
    updatePayload["pillarEstimates.english"] = pillarEstimates.english;
  }

  if (pillarEstimates?.math) {
    updatePayload["pillarEstimates.math"] = pillarEstimates.math;
  }

  if (pillarEstimates) {
    updatePayload["pillarEstimates.updatedAt"] = serverTimestamp();
  }

  /* ---------- override or create today's history entry ---------- */
  if (overallEstimate) {
    const snap = await getDoc(userRef);
    const existing =
      snap.data()?.estimateHistory?.[today] ?? {};

    updatePayload[`estimateHistory.${today}`] = {
      ...existing,
      date: today,
      source,
      updatedAt: serverTimestamp(),

      ...(overallEstimate.english !== undefined && {
        english: overallEstimate.english,
      }),
      ...(overallEstimate.math !== undefined && {
        math: overallEstimate.math,
      }),
      ...(overallEstimate.total !== undefined && {
        total: overallEstimate.total,
      }),
    };
  }

  await updateDoc(userRef, updatePayload);
};
